import { jsx as e, Fragment as c, jsxs as d } from "react/jsx-runtime";
import { useRef as u } from "react";
import { useBreakpointValue as f } from "@chakra-ui/react";
import { Modal as p, ModalHeaderDefault as B, ModalBody as M, ModalFooterDefault as v } from "../Modal/Modal.es.js";
const g = ({
  acceptButtonProps: o,
  cancelButtonProps: r,
  children: a,
  motionPreset: n = "scale",
  title: l,
  ssr: i = !0,
  ...t
}) => {
  const s = u(null), m = f(
    {
      base: "slideInBottom",
      md: n
    },
    { ssr: i }
  );
  return /* @__PURE__ */ e(c, { children: /* @__PURE__ */ d(
    p,
    {
      leastDestructiveRef: s || t.leastDestructiveRef,
      size: "sm",
      motionPreset: m,
      ...t,
      children: [
        /* @__PURE__ */ e(B, { title: l }),
        /* @__PURE__ */ e(M, { children: a }),
        /* @__PURE__ */ e(
          v,
          {
            secondary: {
              component: "Button",
              title: "Cancel",
              variant: "tertiary",
              ...r
            },
            primary: {
              component: "Button",
              title: "Accept",
              variant: "danger",
              ...o
            }
          }
        )
      ]
    }
  ) });
};
export {
  g as AlertModal
};
//# sourceMappingURL=AlertModal.es.js.map
